import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ActionCreators from '../../redux/action';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import ServerErrorModal from '../server-error-modal';
import { useSelector } from 'react-redux';

import {
  ROUTE_DASHBOARD,
  LS_CURRENCY,
  ROUTE_MAILBOX,
  // ROUTE_REQUESTS,
  ROUTE_FAQ,
  ROUTE_FAQ_DETAIL,
  ROUTE_FAQ_RESULTS,
  ROUTE_PROFILE,
  ROUTE_INVESTMENTS,
  ROUTE_INVESTMENT_DETAIL,
  ROUTE_INVEST_MANAGE,
  LS_REDIRECT_URL,
  ROUTE_GUARANTEE_FUND,
  ROUTE_SECONDARY_MARKET,
  ROUTE_EARNINGS_CALCULATOR,
  ROUTE_PHONE_VERIFICATION_REQUIRED,
} from '../../constants';
import Menu from './menu';
import LayoutSC from './layout.styled';
import BorrowerDashboard from '../../pages/borrower/borrower-dashboard/index.js';
import BorrowerMailbox from '../../pages/borrower/borrower-mailbox';
// import BorrowerRequests from '../../pages/borrower/borrower-requests';
import InvestorDashboard from '../../pages/investor/investor-dashboard/index.js';
import InvestorMailbox from '../../pages/investor/investor-mailbox';
// import InvestorRequests from '../../pages/investor/investor-requests';
import InvestorInvestments from '../../pages/investor/investor-investments';
import InvestorInvestmentDetail from '../../pages/investor/investor-investment-detail';
import InvestorInvestManage from '../../pages/investor/investor-invest-manage';
import InvestorSecondaryMarket from '../../pages/investor/investor-secondary-market';
import Profile from '../../pages/profile';
import Faq from '../../pages/faq';
import FaqDetail from '../../pages/faq-detail';
import FaqResults from '../../pages/faq-results';
import Footer from './footer';
import BorrowerOnboarding from '../../pages/borrower-onboarding';
import InvestorOnboarding from '../../pages/investor-onboarding';
import InlineLoading from '../ui/inline-loading';
import GuaranteeFund from '../../pages/guarantee-fund';
import InvestorEarningsCalculator from '../../pages/investor-earnings-calculator';
import OnlineOnboarding from '../../pages/online-onboarding';

const _Layout = (props) => {
  const {
    getUser,
    getInvestorDashboardData,
    getBorrowerDashboardData,
    getInvestorInvestmentInstruction,
    /*     getFAQsCategories,
    getFAQs,
    getMostSearchedFAQsTerms, */
    userType,
    userStep,
    phoneNumberVerified,
    appCurrency,
    setAppCurrency,
    history,
  } = props;

  const userRedux = useSelector(state => state.user);

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const redirectUrl = localStorage.getItem(LS_REDIRECT_URL);
    if (redirectUrl !== null && redirectUrl !== undefined) {
      history.push(redirectUrl);
      localStorage.removeItem(LS_REDIRECT_URL);
    }
  }, [history]);

  // Redirect to phone verification page if phone is not verified
  useEffect(() => {
    if (phoneNumberVerified === false) {
      history.push(ROUTE_PHONE_VERIFICATION_REQUIRED);
    }
  }, [phoneNumberVerified, history]);

  useEffect(() => {
    if (userType !== null && userType === 'investor') {
      getInvestorDashboardData();
      getInvestorInvestmentInstruction();
    } else if (userType !== null && userType === 'debtor') {
      // Prevent dashboard call if access is false
      if (!userRedux.userAreaAccess || userRedux.userAreaAccess.access !== false) {
        getBorrowerDashboardData();
      }
    } else {
      return;
    }
  }, [
    userType,
    getBorrowerDashboardData,
    getInvestorDashboardData,
    getInvestorInvestmentInstruction,
    userRedux.userAreaAccess
  ]);

  useEffect(() => {
    if (!isLoading && userType === 'onboarding-investor' && userStep === 1) {
      history.push(ROUTE_EARNINGS_CALCULATOR);
    }
  }, [history, isLoading, userType, userStep]);

  /* Has UserType | Loading */
  useEffect(() => {
    if (userType !== null) {
      setIsLoading(false);
    } else {
      setIsLoading(true);
    }
  }, [userType]);

  /* Get All Apis */
  useEffect(() => {
    const fetchData = async () => {
      await Promise.all([
        getUser() /* getFAQsCategories(), getFAQs(), getMostSearchedFAQsTerms(3) */,
      ]);
    };
    fetchData();
  }, [getUser /* getFAQsCategories, getFAQs, getMostSearchedFAQsTerms */]);

  /* Set App Currency */
  useEffect(() => {
    if (localStorage.getItem(LS_CURRENCY) !== null) {
      const savedCurrency = localStorage.getItem(LS_CURRENCY);
      setAppCurrency(savedCurrency);
    }
  }, [appCurrency, setAppCurrency]);

  if (isLoading)
    return (
      <LayoutSC>
        <div className="loading-wrap">
          <InlineLoading />
        </div>
      </LayoutSC>
    );

  // Don't render layout if phone is not verified (will be redirected)
  if (phoneNumberVerified === false) {
    return null;
  }

  return (
    <>
      <LayoutSC>
        <Menu />
        {userType === 'investor' ? (
          <Switch>
            <Route exact path={ROUTE_DASHBOARD} component={InvestorDashboard} />
            <Route exact path={ROUTE_MAILBOX} component={InvestorMailbox} />
            {/* <Route exact path={ROUTE_REQUESTS} component={InvestorRequests} /> */}
            <Route exact path={ROUTE_FAQ} component={Faq} />
            <Route exact path={ROUTE_FAQ_DETAIL} component={FaqDetail} />
            <Route exact path={ROUTE_FAQ_RESULTS} component={FaqResults} />
            <Route exact path={ROUTE_PROFILE} component={Profile} />
            <Route exact path={ROUTE_INVESTMENTS} component={InvestorInvestments} />
            <Route exact path={ROUTE_INVESTMENT_DETAIL} component={InvestorInvestmentDetail} />
            <Route exact path={ROUTE_INVEST_MANAGE} component={InvestorInvestManage} />
            <Route exact path={ROUTE_GUARANTEE_FUND} component={GuaranteeFund} />
            <Route exact path={ROUTE_SECONDARY_MARKET} component={InvestorSecondaryMarket} />
            <Redirect to={ROUTE_DASHBOARD} />
          </Switch>
        ) : userType === 'onboarding-debtor' ? (
          <Switch>
            <Route exact path={ROUTE_DASHBOARD} component={BorrowerOnboarding} />
            <Route exact path={ROUTE_MAILBOX} component={BorrowerMailbox} />
            <Redirect to={ROUTE_DASHBOARD} />
          </Switch>
        ) : userType === 'onboarding-online' ? (
          <Switch>
            <Route exact path={ROUTE_DASHBOARD} component={OnlineOnboarding} />
            <Route exact path={ROUTE_MAILBOX} component={BorrowerMailbox} />
            <Redirect to={ROUTE_DASHBOARD} />
          </Switch>
        ) : userType === 'onboarding-investor' ? (
          <Switch>
            <Route exact path={ROUTE_DASHBOARD} component={InvestorOnboarding} />
            <Route exact path={ROUTE_EARNINGS_CALCULATOR} component={InvestorEarningsCalculator} />
            <Route exact path={ROUTE_MAILBOX} component={InvestorMailbox} />
            <Redirect to={ROUTE_DASHBOARD} />
          </Switch>
        ) : userType === 'debtor' ? (
          <Switch>
            <Route exact path={ROUTE_DASHBOARD} component={BorrowerDashboard} />
            <Route exact path={ROUTE_MAILBOX} component={BorrowerMailbox} />
            {/* <Route exact path={ROUTE_REQUESTS} component={BorrowerRequests} /> */}
            <Route exact path={ROUTE_FAQ} component={Faq} />
            <Route exact path={ROUTE_FAQ_DETAIL} component={FaqDetail} />
            <Route exact path={ROUTE_FAQ_RESULTS} component={FaqResults} />
            <Route exact path={ROUTE_PROFILE} component={Profile} />
            <Redirect to={ROUTE_DASHBOARD} />
          </Switch>
        ) : null}
      </LayoutSC>
      <Footer />
      <ServerErrorModal />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    appCurrency: state.app.currency,
    userType: state.user.type,
    userStep: state.user.onboarding_step,
    phoneNumberVerified: state.user.phone_number_verified,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getInvestorDashboardData: ActionCreators.getInvestorDashboardData,
      getBorrowerDashboardData: ActionCreators.getBorrowerDashboardData,
      getInvestorInvestmentInstruction: ActionCreators.getInvestorInvestmentInstruction,
      getUser: ActionCreators.getUserData,
      /*       getFAQsCategories: ActionCreators.getFAQsCategories,
      getFAQs: ActionCreators.getFAQs,
      getMostSearchedFAQsTerms: ActionCreators.getMostSearchedFAQsTerms, */
      setAppCurrency: ActionCreators.setAppCurrency,
    },
    dispatch
  );
};

const Layout = withRouter(connect(mapStateToProps, mapDispatchToProps)(_Layout));

export default Layout;
